import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getSystemConfigStructureFetch as getSystemConfigStructureFetchAction,
    getSystemConfigDetailFetchSuccess,
    getSystemConfigDetailFetchFailure,
    updateSystemConfigDetailFetchSuccess,
    updateSystemConfigDetailFetchFailure,
    getSystemConfigStructureFetchSuccess,
    getSystemConfigStructureFetchFailure,
    createSystemConfigStructureFetchSuccess,
    createSystemConfigStructureFetchFailure,
    updateSystemConfigStructureFetchSuccess,
    updateSystemConfigStructureFetchFailure,
} from './reducer';
import {
    SystemConfigDetailResType,
    SystemConfigItemType,
    SystemConfigStructureItemType,
} from 'src/types/systemConfigDetail';
import translate from '@translate';

const getSystemConfigDetailFetchRequest = async () => {
    const res = await api('get', `api/secure/system-configs`);
    return res.data;
};

function* getSystemConfigDetailFetch(action: { type: string }) {
    try {
        const response: SystemConfigDetailResType = yield call((): any => getSystemConfigDetailFetchRequest());
        yield put(getSystemConfigDetailFetchSuccess(response));
    } catch (error) {
        yield put(getSystemConfigDetailFetchFailure({ error }));
    }
}

export function* getSystemConfigDetailFetchWatch() {
    yield takeEvery('systemConfigDetail/getSystemConfigDetailFetch', getSystemConfigDetailFetch);
}

const updateSystemConfigDetailFetchRequest = async (params: SystemConfigItemType[]) => {
    const res = await api('put', `api/secure/system-configs`, params);
    return res.data;
};

function* updateSystemConfigDetailFetch(action: { type: string; payload: SystemConfigItemType[] }) {
    try {
        const response: SystemConfigDetailResType = yield call((): any =>
            updateSystemConfigDetailFetchRequest(action.payload)
        );
        yield put(
            updateSystemConfigDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('systemConfigDetail.message.update') },
            })
        );
    } catch (error) {
        yield put(updateSystemConfigDetailFetchFailure({ error }));
    }
}

export function* updateSystemConfigDetailFetchWatch() {
    yield takeEvery('systemConfigDetail/updateSystemConfigDetailFetch', updateSystemConfigDetailFetch);
}

const getSystemConfigStructureFetchRequest = async () => {
    const res = await api('get', `api/secure/system-configs/structure`);
    return res.data;
};

function* getSystemConfigStructureFetch(action: { type: string }) {
    try {
        const response: SystemConfigDetailResType = yield call((): any => getSystemConfigStructureFetchRequest());
        yield put(getSystemConfigStructureFetchSuccess(response));
    } catch (error) {
        yield put(getSystemConfigStructureFetchFailure({ error }));
    }
}

export function* getSystemConfigStructureFetchWatch() {
    yield takeEvery('systemConfigDetail/getSystemConfigStructureFetch', getSystemConfigStructureFetch);
}

const createSystemConfigStructureFetchRequest = async (data: SystemConfigStructureItemType) => {
    const res = await api('post', `api/secure/system-configs/structure`, data);
    return res.data;
};

function* createSystemConfigStructureFetch(action: { type: string; payload: SystemConfigStructureItemType }) {
    try {
        const response: SystemConfigDetailResType = yield call((): any =>
            createSystemConfigStructureFetchRequest(action.payload)
        );
        yield put(createSystemConfigStructureFetchSuccess(response));
        yield put(getSystemConfigStructureFetchAction());
    } catch (error) {
        yield put(createSystemConfigStructureFetchFailure({ error }));
    }
}

export function* createSystemConfigStructureFetchWatch() {
    yield takeEvery('systemConfigDetail/createSystemConfigStructureFetch', createSystemConfigStructureFetch);
}

const updateSystemConfigStructureFetchRequest = async (params: { id: string; data: SystemConfigStructureItemType }) => {
    const res = await api('put', `api/secure/system-configs/structure/${params.id}`, params.data);
    return res.data;
};

function* updateSystemConfigStructureFetch(action: {
    type: string;
    payload: { id: string; data: SystemConfigStructureItemType };
}) {
    try {
        const response: SystemConfigDetailResType = yield call((): any =>
            updateSystemConfigStructureFetchRequest(action.payload)
        );
        yield put(updateSystemConfigStructureFetchSuccess(response));
        yield put(getSystemConfigStructureFetchAction());
    } catch (error) {
        yield put(updateSystemConfigStructureFetchFailure({ error }));
    }
}

export function* updateSystemConfigStructureFetchWatch() {
    yield takeEvery('systemConfigDetail/updateSystemConfigStructureFetch', updateSystemConfigStructureFetch);
}
